import {ENDPOINTS} from '../common/endpoints';
import {GuidLightDto} from '../models/common/IGuidLight';
import {
FillingGuidDto,
FillingGuidListParams,
FillingGuidListResponse,
SaveFillingGuidRequest
} from '../models/Recipe/Filling/IFillingGuid';
import {baseAPI} from './BaseAPI';
import {TAGS} from "./TagTypes";

export const fillingAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getFillingsV2: build.query<FillingGuidListResponse, FillingGuidListParams>({
            query: params => ({url: ENDPOINTS.FILLINGS.V2, method: 'GET', params}),
            providesTags: [TAGS.FILLINGS],
        }),
        getFillingsV2AllLight: build.query<GuidLightDto[], void>({
            query: () => ({url: ENDPOINTS.FILLINGS.V2_ALL_LIGHT, method: 'GET'}),
            providesTags: [TAGS.FILLINGS_LIGHT],
        }),
        getFillingV2: build.query<FillingGuidDto, string>({
            query: id => ({url: `${ENDPOINTS.FILLINGS.V2}/${id}`, method: 'GET'}),
            providesTags: (_result, _error, id) => [{type: TAGS.FILLING, id}],
        }),
        createFillingV2: build.mutation<FillingGuidDto, SaveFillingGuidRequest>({
            query: body => ({url: ENDPOINTS.FILLINGS.V2, method: 'POST', body}),
            invalidatesTags: [TAGS.FILLINGS, TAGS.FILLINGS_LIGHT, TAGS.RECIPES, TAGS.RECIPES_LIGHT],
        }),
        updateFillingV2: build.mutation<FillingGuidDto, {id: string; body: SaveFillingGuidRequest}>({
            query: ({id, body}) => ({url: `${ENDPOINTS.FILLINGS.V2}/${id}`, method: 'PUT', body}),
            invalidatesTags: (_result, _error, {id}) => [TAGS.FILLINGS, {type: TAGS.FILLING, id}, TAGS.FILLINGS_LIGHT, TAGS.RECIPES, TAGS.RECIPES_LIGHT, TAGS.RECIPES_FOR_ORDER],
        }),
        deleteFillingV2: build.mutation<void, string>({
            query: id => ({url: `${ENDPOINTS.FILLINGS.V2}/${id}`, method: 'DELETE'}),
            // Keep the deleted detail cache untouched until the page unmounts;
            // invalidating it here causes a redundant GET that correctly returns 404.
            invalidatesTags: [TAGS.FILLINGS, TAGS.FILLINGS_LIGHT, TAGS.RECIPES, TAGS.RECIPES_LIGHT, TAGS.RECIPES_FOR_ORDER],
        }),
    }),
});
